import { Component, Vue } from 'vue-property-decorator';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import WithRender from './product.html';
import { ProductRow, PriceList } from '@/types/ProductTypes';
import VuePhoneNumberInput from "vue-phone-number-input";
import prdts from "@/settings/products";
import { ProductSettings, ProductData } from '@/types/productSettingTypes';
import { mapGetters } from 'vuex';

@WithRender
@Component({
  components: {
    Loading,
    VuePhoneNumberInput
  },
  computed: {
    ...mapGetters("originatorStore", {originator:"getOriginator",currency:"getWalletCurrency"}),
  }
})
export default class Product extends Vue {
  originator!: string;
  priceList: PriceList = {} as PriceList;
  selectedProduct = {} as ProductRow;
  productSetting: ProductSettings = prdts;
  product = {} as ProductData;
  valideReceiverNumberMessage = '';
  valideSenderNumberMessage = '';
  isLoading = true;
  senderNumber = '';
  receiverNumber = '';
  senderNumberWithCountryCode = '';
  receiverNumberwithCountryCode = '';

  created() {
    this.product = this.productSetting.products.find(x => x.portiFolio == this.$route.query.portiFolio as string && x.isoCountry == this.$route.query.c as string) as ProductData;
  }

  mounted() {
    if (!this.product) {
      this.$router.push({ name: "Country" });
      return;
    }
    this.getPriceList(this.product.portiFolio)
  }

  private getPriceList(portiFolio: string) {
    this.isLoading = true;
    let dto =
    {
      portiFolio,
      originator: this.originator,
      parameters:null
    }
    this.$store.dispatch("product/GetPortiFolioOnlyProducts", dto)
    .then(value => {
     this.priceList = value as PriceList;
    })
    .catch(err => { console.error(err); })
    .finally(() => {
      this.isLoading = false;
    });
  }

  ValidateSenderNumber(payload: any) {
    this.senderNumberWithCountryCode = payload.countryCallingCode + payload.nationalNumber;
    if (payload.isValid) {
      this.valideSenderNumberMessage = '';
    } else {
      this.valideSenderNumberMessage = "Please make sure mobile number is valid!";
    }
  }

  ValidateReceiverNumber(payload: any) {
    this.receiverNumberwithCountryCode = payload.countryCallingCode + payload.nationalNumber;
    if (payload.isValid) {
      this.valideReceiverNumberMessage = '';
    } else {
      this.valideReceiverNumberMessage = "Please make sure mobile number is valid!";
    }
  }

  private productDescription(): string {
    if (this.selectedProduct.description)
      return `${this.selectedProduct.description} for ${this.receiverNumberwithCountryCode}`;
    const description = (this.product.displaySalesCurrency ? `(${this.product.isoCurrency} ${this.selectedProduct.salesCurrencyAmount})` : '');
    return `${this.product.text} for ${this.receiverNumberwithCountryCode} ${description}`;
  }

  async CheckOutProduct() {
    const checkOut = {
      key: this.priceList.key,
      salesCurrencyAmount: this.selectedProduct.salesCurrencyAmount,
      totalAmount: this.selectedProduct.totalAmount,
      description: this.productDescription(),
      senderNumber: this.senderNumberWithCountryCode,
      receiveNumber: this.receiverNumberwithCountryCode,
      portiFolio: this.product.portiFolio,
      itemName: this.product.text,
      accountNo: this.receiverNumberwithCountryCode,
      isoCountry: this.product.isoCountry,
      extra1: this.selectedProduct.extra1
    }
    //if (this.valideSenderNumberMessage !== '' || this.valideReceiverNumberMessage !== '')
    //return;

    await this.$store.dispatch("shoppingCart/addToCart", checkOut);
    this.$router.push("Checkout");
  }
}
